#include <begin_vertex>

#include "angle_matrix_definition.glsl"
transformed.xz = rotationMatrix * transformed.xz;
